import React, { Component, createElement } from 'react'

import { Switch, Route } from 'react-router-dom'
import createHistory from 'history/createHashHistory'

import { combineReducers, createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { reducer as formReducer } from 'redux-form'
import { ConnectedRouter, routerMiddleware, routerReducer } from 'react-router-redux'
import createSagaMiddleware from 'redux-saga'
import createLogger from 'redux-logger'

import appLayout from './components/layout/Layout'
import { Login, Logout, loginFrontendPath } from './routes/auth'
import { Dashboard as dashboard } from './routes/dashboard'
import PermissionPlaceholder from './auth/PermissionPlaceholder'

import adminReducer from './reducers'

import { crudSaga, customSaga } from './sideEffect/saga'
import { resources, customRoutes } from './routes'
import { rawRestClient, rawCustomClient, } from './api'
import rawAuthClient from './authClient'

import { fork } from 'redux-saga/effects';

const configureStore = (history, resources) => {

  const sagaMiddleware = createSagaMiddleware();
  const middleware = [sagaMiddleware, routerMiddleware(history)];
  // Send request to the same domain in production
  const restClient = rawRestClient('');
  const authClient = rawAuthClient('');
  const customClient = rawCustomClient('');
  if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger);
  }

  const restClientWithTimeout = (type, resource, params) => {
    return new Promise(resolve => setTimeout(() => resolve(restClient(type, resource, params)), 500));
  };
  const customClientWithTimeout = (type, resource, params) => {
    return new Promise(resolve => setTimeout(() => resolve(customClient(type, resource, params)), 500));
  };

  const appReducer = combineReducers({
    admin: adminReducer(resources),
    form: formReducer,
    routing: routerReducer
  });

  const store = createStore(
    appReducer,
    applyMiddleware(...middleware)
  );

  const saga = function* rootSaga() {
    yield [
      crudSaga(restClientWithTimeout, authClient),
      customSaga(customClientWithTimeout),
    ].map(fork);
  };
  sagaMiddleware.run(saga);
  return store;
};


const params = {
  client_id: '622450700549-cj8j49v78bhnij9vvp9ni9j8o3g1m49l.apps.googleusercontent.com',
  fetch_basic_profile: true,
};

window.gapi.load('auth2', () => {
  window.gapi.auth2.init(params);
});


class App extends Component {

  render() {
    const history = createHistory();
    const store = configureStore(history, resources);
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div>
            <Route path={"/"} component={PermissionPlaceholder}/>
            <Switch>
              <Route exact path={loginFrontendPath} component={Login}/>
              <Route path="/" render={() => createElement(appLayout, {
                customRoutes,
                resources,
                dashboard,
                Logout,
              })}/>
            </Switch>
          </div>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js